import { useGetAllBusses } from '@/hooks/data/masterDataHook';
import { Select, SelectProps } from 'antd';
import React from 'react';

interface Props extends SelectProps<any> {}

export default function BusInput({ onChange, ...props }: Props) {
  const { data, isLoading } = useGetAllBusses();

  const options: any[] = React.useMemo(() => {
    return (
      data?.data?.map(c => {
        return {
          label: `${c.plateNumber} - ${c.busName}`,
          value: c.id,
        };
      }) || []
    );
  }, [data]);

  return (
    <Select
      maxTagCount="responsive"
      {...props}
      loading={isLoading}
      showSearch
      allowClear
      onChange={onChange}
      options={options}
      filterOption={(input, option) => {
        return (option?.children as any)?.toLowerCase().includes(input.toLowerCase());
      }}
    />
  );
}
